import { render, staticRenderFns } from "./DiscussionForumDetails.vue?vue&type=template&id=00c3eac2&scoped=true&"
import script from "./DiscussionForumDetails.vue?vue&type=script&lang=js&"
export * from "./DiscussionForumDetails.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionForumDetails.vue?vue&type=style&index=0&id=00c3eac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c3eac2",
  null
  
)

export default component.exports